import React, { useMemo } from 'react';
import { Select, Form } from 'antd';
import { useUserContextHook } from '../../../hooks/useUserContextHook';
import { dropDownMapping } from '../../../utils/app-common';
import { usePromiseTracker } from 'react-promise-tracker';

export interface OriginOption {
  id: string | number;
  value: string;
  regionId?: string | number;
  regionName?: string;
}

interface OriginDropDownProps {
  name?: string;
  label?: string;
  onSelect?: (value: string | number, option: any) => void;
  allowClear?: boolean;
  showSearch?: boolean;
  disabled?: boolean;
  value?: string | number | (string | number)[];
  isMultiple?: boolean;
  required?: boolean;
  className?: string;
  selectValue?: string;
  valueByName?: boolean;
  onChange?: (value: string | number | (string | number)[]) => void;
  regionId?: string | number | (string | number)[];
  regionName?: string | number | (string | number)[];
  size?: 'small' | 'middle' | 'large';
  placeHolder?: string;
}

const OriginAndDestinationDropDown: React.FC<OriginDropDownProps> = ({
  name = 'origincityID',
  label = 'Origin',
  placeHolder,
  onSelect,
  allowClear = true,
  showSearch = true,
  disabled = false,
  isMultiple = false,
  required = false,
  className = '',
  value,
  selectValue,
  valueByName = false,
  onChange = () => {},
  regionId,
  regionName,
  size = 'small',
}) => {
  const { masterDetail } = useUserContextHook();
  const { promiseInProgress: masterProgress } = usePromiseTracker({
    area: 'get-master-area',
  });

  const cityListMemo = useMemo(() => {
    const cityList = dropDownMapping(masterDetail?.city, 'cityId', 'city') || [];
    if (regionId) {
      const regionArray = Array.isArray(regionId) ? regionId : [regionId];
      return cityList.filter((city) => regionArray.includes(city.regionId));
    }

    if (regionName) {
      const regionArray = Array.isArray(regionName) ? regionName : [regionName];
      return cityList.filter((city) => regionArray.includes(city.regionName));
    }

    return cityList;
  }, [masterDetail?.city, regionId, regionName]);

  return (
    <Form.Item
      name={name}
      label={label || undefined}
      labelCol={{ span: 24 }}
      rules={[{ required, message: `${label} is required` }]}
    >
      <Select
        className={className}
        loading={masterProgress}
        mode={isMultiple ? 'multiple' : undefined}
        value={value}
        disabled={disabled}
        showSearch={showSearch}
        allowClear={allowClear}
        onSelect={onSelect}
        size={size}
        onChange={onChange}
        placeholder={placeHolder}
        filterOption={(input, option) => (option?.children as string)?.toLowerCase()?.includes(input?.toLowerCase())}
        maxTagCount={2}
        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
      >
        {cityListMemo.map((origin) => (
          <Select.Option key={origin.id} value={selectValue ? origin[selectValue] : origin.id} title={origin.value}>
            {origin.value}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default OriginAndDestinationDropDown;
